module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=MF - Saint Martin.a8d330e0.svg";